import React from 'react';
import PropTypes from 'prop-types';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import {
    isEmpty,
    extractWorkSheetData,
    getWithExpiry
} from "../../../globals/GlobalFunctions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import axios from 'axios';
import {refreshToken} from "../../../globals/GlobalFunctions";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";

export interface Props {
    excelData: any;
    currentDB: string;
}

function BulkPlanImporter({excelData, currentDB}: Props) {
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);
    const [validationText, setValidationText] = React.useState("");
    const [validationError, setValidationError] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [planImport, setPlanImport] = React.useState({plan_ID: "",
        description: "", plan_Type: "", vbasoftware_database: "CoastalAdminTest", vbapi_Token: ""});

    let token = localStorage.getItem('jwt');

    const handleValidationClose = () => {
        setValidationError(false);
        setValidationText("");
    }

    const initialPlanImport = {
        plan_ID: "",
        description: "",
        plan_Type: "",
        vbasoftware_database: "CoastalAdminTest",
        vbapi_Token: "",
    }

    const clearPlanImport = () => {
        setPlanImport({...initialPlanImport});
    }

    const importPlanImports = async (planImportArray : any[]) => {
        refreshToken();
        setIsLoading(true);
        const response =
            await axios
                .put(
                    localStorage.getItem('baseURL') + 'Plan/putList',
                    planImportArray,
                    {headers: {'Authorization': `Bearer ${token}`, accept: "*/*", "Content-Type": "application/json"}}
                ).then(() => {
                    setLoading(false);
                    setSuccessAlert(true);
                    setIsLoading(false);
                }).catch((error) => {
                    //console.log(response);
                    setLoading(false);
                    setValidationText(error.response.request.responseText);
                    setValidationError(true);
                    setIsLoading(false);
                });
        //console.log(response);
    }

    try {
        //Check for data and that there is a sheet in the data named IDCodeValue
        if (!isEmpty(excelData) && excelData.Sheets.Plans !== undefined) {
            //console.log(excelData, "Made it to formatter!");

            //global function to extract the data into a sequential array of cell data values as well as the column and row ranges
            let sheetDataArray = extractWorkSheetData(excelData.Sheets.Plans);

            let rawCellArray: any[] = sheetDataArray[0];

            let columnRange: number = sheetDataArray[1];

            let rowRange: number = sheetDataArray[2];

            let planImportArray: any[] = [];

            //console.log(rawCellArray, "Raw Data");

            //we need to find the column index of the values we require so we can grab the data for each row -- THIS IS WHERE COLUMN NAMES ARE SET
            //we add 1 for each for the loop multiplier to account for it being zero based, but later we subtract 1 to account for the very fist row actually starting at zero
            const planIndexCollection = {
                planIndex: rawCellArray.indexOf('Plan ID') + 1,
                descriptionIndex: rawCellArray.indexOf('Description') + 1,
                planTypeIndex: rawCellArray.indexOf('Plan Type') + 1,
            }

            if(planIndexCollection.planIndex > 0 && planIndexCollection.descriptionIndex > 0 && planIndexCollection.planTypeIndex > 0) {

                for (let i = 1; i < rowRange; i++) {
                    //for each new array we skip over the previous records determined by the column length, removing 1 to account for our zero based index at the beginning
                    let rowMultiplier = columnRange * i - 1;

                    //start with group
                    if (planIndexCollection.planIndex > 0) {
                        planImport.plan_ID = rawCellArray[(rowMultiplier + planIndexCollection.planIndex)].toString();
                    }

                    //old division
                    if (planIndexCollection.descriptionIndex > 0) {
                        planImport.description = rawCellArray[(rowMultiplier + planIndexCollection.descriptionIndex)].toString();
                    }

                    //new division
                    if (planIndexCollection.planTypeIndex > 0) {
                        planImport.plan_Type = rawCellArray[(rowMultiplier + planIndexCollection.planTypeIndex)].toString();
                    }

                    planImport.vbasoftware_database = currentDB;

                    planImport.vbapi_Token = getWithExpiry('vbapi_Token');

                    if(planImport.plan_ID.length > 0 && planImport.description.length > 0
                        && planImport.plan_Type.length > 0) {
                        planImportArray.push({...planImport});
                    }

                    planImport.plan_ID = initialPlanImport.plan_ID;
                    planImport.description = initialPlanImport.description;
                    planImport.plan_Type = initialPlanImport.plan_Type;

                    clearPlanImport();
                }

                importPlanImports(planImportArray);

                excelData.Sheets.Plans = undefined;
            }
            else {
                //setValidationText("Group ID, Plan ID, and Vendor are required.");
                //setValidationError(true);
            }

        }
    }
    catch(e) {
        console.log("ERROR", e);

        setErrorAlert(true);
        //clear it out after errors in case of rerendering otherwise the error spams will continue until morale improves
        excelData.Sheets.Plans = undefined;
    }

    return (
        <div>
            {successAlert ? <Alert className="groupAlertStyles" severity='success' onClose={() => setSuccessAlert(false)} variant="filled">
                <AlertTitle>Success!</AlertTitle>
                Bulk Plan Import Complete!
            </Alert> : <></> }
            {errorAlert ? <Alert className="groupAlertStyles" severity='error' onClose={() => setErrorAlert(false)} variant="filled">
                <AlertTitle>Error!</AlertTitle>
                There was an error with this file!
            </Alert> : <></> }
            <Dialog
                open={validationError}
                onClose={handleValidationClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    {"Validation Error"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {validationText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleValidationClose}>OK</Button>
                </DialogActions>
            </Dialog>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
}

export default React.memo(BulkPlanImporter)

BulkPlanImporter.propTypes = {
    excelData: PropTypes.object.isRequired
};
